import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import { ToggleButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToggleButton } from "../AppToggleButton";

export const PreviewToggleButton = (props: ToggleButtonProps) => (
    <AppToggleButton
        sx={{ marginRight: ".5rem" }}
        {...props}
        tooltip={Translations.TogglePreviewPanel}
    >
        <PreviewOutlinedIcon />
    </AppToggleButton>
);
